// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9nbk6","logo":"Header_logo__heMk+"};